import {
    AbstractedUpsellCategory,
    AbstractedUpsellItem,
    PriceType,
    UpsellFacetValue,
} from '@vfde-sails/glados-v2';

/**
 * Get the correct price item per category
 * @todo This is not a good idea. The feature card should allow us to display all the prices we get for a single product
 */
export const getPriceForProduct = (
    prices: AbstractedUpsellItem['price'],
    category: Omit<AbstractedUpsellCategory, 'order'>,
): typeof prices[number] | undefined => {
    switch (category.value) {
        case UpsellFacetValue.Accessory:
            return prices.find(price => price.type === PriceType.Onetime);
        case UpsellFacetValue.Redplus:
        case UpsellFacetValue.Insurance:
            return prices.find(price => price.type === PriceType.Monthly);
    }
};
